import * as PIXI from "pixi.js";
import TimerRendererFactory from "./TimerRendererFactory";
import { Coord } from "../../types/Interface";


export default class TimerRenderer extends PIXI.Container {
  private bg = this.addChild(new PIXI.Graphics());
  private PieTimer = this.addChild(new PIXI.Graphics());
  private TimerText = this.addChild(new PIXI.Text());

  constructor(private con: PIXI.Container, coord: Coord, private initSeconds: number) {
    super();
    this.addToCon();
    this.deactiveEventMode();
    this.drawInit();
    this.position.copyFrom(coord)
  }
  private addToCon = () => this.con.addChild(this);
  private drawInit = () => TimerRendererFactory.drawInitTimerText(this.TimerText);
  private deactiveEventMode = () => [this.bg, this.PieTimer, this.TimerText].forEach(e => e.eventMode = "none"); 
  
  draw(seconds: number) {
    this.TimerText.text = TimerRendererFactory.formatTimerText(seconds);
    TimerRendererFactory.drawPieTimer(this.PieTimer, this.initSeconds, seconds);
    TimerRendererFactory.drawBg(this.bg, this.TimerText.x, this.TimerText.width);
  }
}